export const escapeStringForRegExp = (input: string) => {
  // taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
  return input.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
};

export const stringToRegExp = (input: string, flags?: string): RegExp => {
  const escaped = escapeStringForRegExp(input);
  return new RegExp(escaped, flags);
};
